/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ChannelUsersArgs, User, channelsNewApi } from '../services';
import { PaginationInfo } from '../shared';

interface ChannelUsersState {
  isFetched: boolean;
  users: User[];
  pageInfo: PaginationInfo;
}

const initialState: ChannelUsersState = {
  isFetched: false,
  users: [],
  pageInfo: {
    page: 0,
    perPage: 0,
    hasNextPage: false,
    hasPreviousPage: false,
    totalItems: 0,
    totalPages: 0,
  },
};

const getChannelUsersHandler = async (args: ChannelUsersArgs, { dispatch }: any) => {
  return dispatch(channelsNewApi.endpoints.channelUsers.initiate({ ...args })).unwrap();
};

export const getChannelUsers = createAsyncThunk('getChannelUsers', getChannelUsersHandler);

const ChannelUsersSlice = createSlice({
  name: 'ChannelUsersSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getChannelUsers.pending, (state) => {
        state.isFetched = false;
      })
      .addCase(getChannelUsers.fulfilled, (state, action) => {
        const { items, pageInfo } = action.payload;

        state.isFetched = true;
        state.users = items;
        state.pageInfo = pageInfo;
      });
  },
});

export default ChannelUsersSlice.reducer;
